<p-select [(ngModel)]="place" (onChange)="onSelectNewPlace()"
          name="place" [disabled]="mode !== DetailMode.EDITION"
          [options]="places" optionLabel="name" dataKey="id"
          [filter]="true" filterBy="name" appendTo="body"
          [showClear]="true" i18n-placeholder="@@common-none" placeholder="(none)"
          [required]="required" class="acted-highlight-req metadata-field" [tabindex]="tabindex">
  <!-- define custom template for filter options -->
  <ng-template pTemplate="item" let-place>
    {{ place.admin_zone_2?.admin_zone_1?.country[filterLabelField] }}: {{ place.name }}
  </ng-template>
</p-select>
